<template>
  <div></div>
</template>
<script>
import { BindweChat, getBindweChat, getToken } from '@/utils/Token';
import { getWechatOauth, bindWechat, getuser } from '@/api/user'

async function getUser () {
  const result = await getuser()
  return result.data.data
}

export default {
  name: 'UserInfoHandle',
  methods: {
    // 获取微信认证
    async getWechatOauth () {
      if (!getToken() && !getBindweChat()) {
        const userInfo = await getUser()
        // 是否绑定微信
        if (!userInfo.isBindWechat) {
          BindweChat()
          //调用微信绑定
          const result = await getWechatOauth({
            state: '/#/UserInfoHandle'
          })

          if (result.data.data.status) {
            window.location = result.data.data.oauthUrl
          }

        } else {
          this.$router.replace('/home')
        }
      }
    },

    // 绑定微信用户
    async bindWeCaht () {
      const code = this.$route.query.wx_code
      if (code) {
        const result = await bindWechat({ code: code })
        const data = result.data.data

        if (data.status || Number(data.error_code) === 20101 || Number(data.error_code) === 20102) {
          this.$router.replace('/home')
        }
      }
    }
  },
  created () {
    const code = this.$route.query.wx_code
    if (code) {
      this.bindWeCaht()
    } else {
      if (this.$isWeChatWeb) {
        this.getWechatOauth()
      } else {
        this.$router.replace('/home')
      }
    }
  }
}
</script>
